/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath, applyAspectRatioBoxStyles } from '@tcp/core/src/utils';

const ICON_NAME = 'icon-carrot-grey-large';

export default css`
  .product-list {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
    }
  }

  .similar-items-wrapper {
    height: auto;
    width: auto;
    gap: 16px;
    display: flex;
    flex-direction: column;
    margin-top: 4px;
    padding-bottom: 18px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 10px;
      padding-bottom: 22px;
    }
  }

  .similar-items-header-wrapper {
    display: flex;
    flex-direction: column;
  }

  .similar-items-header-wrapper p {
    color: #595959;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    letter-spacing: 0.14px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 12px;
      width: 253px;
    }
  }

  .similarProductCarousel .carousel-content {
    display: flex;
    transition: transform 0.5s ease-in-out;
    height: 100%;
    gap: 0;
  }

  .similarProductCarousel .carousel-arrows .right-arrow {
    position: absolute; /* Assuming you want to position it absolutely */
    right: 26px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #d8d8d8; /* Use hex for consistency */
    background-color: rgba(255, 255, 255, 0.9);
    background-image: url(${(props) => getIconPath(ICON_NAME, props)});
    background-position: center;
    background-repeat: no-repeat;
  }

  .similarProductCarousel .carousel-arrows .left-arrow {
    position: absolute; /* Assuming you want to position it absolutely */
    left: 26px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #d8d8d8; /* Use hex for consistency */
    background-color: rgba(255, 255, 255, 0.9);
    background-image: url(${(props) => getIconPath(ICON_NAME, props)});
    background-position: center;
    background-repeat: no-repeat;
  }

  .product-image {
    overflow: hidden;
    height: 100%;
    width: 146px;
    object-fit: cover;
  }

  .carousel-item {
    flex-shrink: 0;
    width: 146px;
    height: 179px;
    margin-right: 16px;
    cursor: pointer;
    @media ${(props) => props.theme.mediaQuery.smallMax},
      ${(props) => props.theme.mediaQuery.mediumMax} {
      &:nth-last-child(2) {
        margin-right: 0;
      }
    }
  }

  .similar-styles-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .similar-styles-header h3 {
    font-family: Nunito;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%; /* 1.5 */
    letter-spacing: 1%; /* 1% of font size */
    text-transform: capitalize;
    height: auto;
    margin: 0;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 16px;
    }
  }

  .view-all-link {
    color: #005d95;
    font-family: Nunito;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 24px */
    width: auto;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    text-transform: capitalize;
    cursor: pointer;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 14px;
    }
  }

  .pdp-redesign-price-and-promo-wrapper {
    margin-bottom: 24px;

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: 32px;
    }
  }

  .pdp-redesign-gift-card-price {
    display: flex;
    padding: 0;
    margin: 0 0 24px 0;

    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0 0 32px 0;
    }
  }

  .top-rated-badge-container {
    position: relative;
    z-index: 1;
    padding: 11px 0 12px;
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: unset;
      top: 6px;
    }
  }

  .plcc-list-price {
    text-decoration: line-through;
    font-weight: bold;
  }

  .plcc-offer-price {
    color: ${(props) => props.theme.colorPalette.red[500]};
    font-weight: bold;
  }

  .hardcoded-plcc-wrapper {
    display: flex;
    flex: 1;
    height: 40px;
    padding-top: 7px;
  }
  .plcc-text-wrapper {
    font-size: 13px;
    line-height: 1;
    margin-top: 5px;
    ${(props) => (!props.isPlccPriceOnPDP ? `font-weight:700;` : '')}
  }
  .hardcoded-plcc-text {
    white-space: pre;
  }
  .hardcoded-plcc {
    width: 427px;
    align-items: center;
    display: flex;
  }
  .hardcoded-plcc.image {
    padding-right: 7px;
    width: 41px;
    height: 26px;
    margin-top: 4px;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-top: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 10px;
      padding-right: 6px;
    }
  }
  .hardcoded-plcc-anchor {
    position: relative;
    ${(props) => (props.isNewPJPPDPRedesignEnabled ? `flex:1;` : ``)}
    font-family: ${(props) => props.theme.typography.fonts.secondary};
  }
  .hardcoded-plcc-text.text1 {
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
  }
  .hardcoded-plcc-text.text2 {
    color: #e86726;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .hardcoded-plcc-text.text3 {
    color: ${(props) => props.theme.colors.REWARDS.PLCC};
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
  }
  .hardcoded-plcc-text.text4 {
    color: #e2499b;
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
  }
  .hardcoded-plcc-text.text5 {
    color: ${(props) => props.theme.colors.PRIMARY.GRAY};
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    ${(props) => (!props.isPlccPriceOnPDP ? `margin-right: 3px;` : '')}
  }

  .hardcoded-plcc-text.text7 {
    white-space: initial;
    ${(props) =>
      props.isPlccPriceOnPDP
        ? `
    @media ${props.theme.mediaQuery.large} {
      white-space: nowrap;
    }`
        : ``}
  }
  .hardcoded-plcc-text.text6 {
    font-size: 14px;
    border: none;
    background: none;
    text-decoration: underline;
    color: ${(props) => props.theme.colors.BUTTON?.BLUE?.NEW_FILTER_BTN};
    cursor: pointer;

    ${(props) =>
      props.isNewPJPPDPRedesignEnabled
        ? `
    @media ${props.theme.mediaQuery.large} {
      position:absolute;
      right:0;
    }`
        : ``}
  }
  .promo-section-parent {
    margin-top: 10px;
  }

  .visually-similar-wrapper {
    margin-top: 24px;

    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-left: 14px;
      margin-top: 16px;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: 15px;
    }

    .visually-similar-header {
      display: flex;
      align-items: center;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      font-family: 'Nunito', sans-serif;
      margin-bottom: 16px;
      width: auto;
      color: #000; /* Optional: set your desired text color */
      position: relative;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        font-size: 16px;
      }
    }

    .visually-similar-header::before {
      content: '';
      flex: 1;
      border-top: 1px solid #000;
      margin-right: 20px; /* Space to the right of the line */
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        margin-right: 10px;
      }
    }

    .visually-similar-header::after {
      content: '';
      flex: 1;
      border-top: 1px solid #000;
      margin-left: 20px; /* Space to the left of the line */
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        margin-left: 10px;
      }
    }
  }

  .visually-similar-carousel {
    margin-bottom: 24px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-bottom: 16px;
    }

    .tab-product-section {
      padding: 0;
    }

    .tab-added-to-bag {
      width: 44px;
      height: 44px;
      margin-right: 16px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        width: 32px;
        height: 32px;
      }
    }

    .tab-atb-icon-image {
      width: 44px;
      height: 44px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        width: 32px;
        height: 32px;
      }
    }

    .carousel-content {
      gap: 0;
      @media (min-width: 340px) and (max-width: 1200px) {
        overflow-x: auto;
      }
    }

    .tile-wrapper {
      flex: 0 0 163px;
      min-height: 299px;
      margin-right: 0;
      width: 265px;
      padding: 0;
      border: 0;
      gap: 0;
      @media ${(props) => props.theme.mediaQuery.large} {
        min-width: 265px;
        margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
      }

      @media (min-width: 340px) and (max-width: 380px) {
        flex: 0 0 153px;
        min-height: 287px;
        margin-right: 8px;
        gap: 0;
      }

      @media (min-width: 350px) and (max-width: 450px),
        (min-width: 760px) and (max-width: 850px),
        (min-width: 910px) and (max-width: 960px) {
        margin-right: 8px;
      }

      @media (min-width: 500px) and (max-width: 550px),
        (min-width: 680px) and (max-width: 730px),
        (min-width: 850px) and (max-width: 900px),
        (min-width: 1024px) and (max-width: 1064px) {
        flex: 0 0 175px;
        min-height: 314px;
        margin-right: 8px;
        gap: 0;
      }
    }

    .tab-product-img {
      display: block;
      width: 100%;
      position: relative;
      overflow: hidden;
      margin-bottom: 12px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        margin-bottom: 8px;
      }
    }

    .moduleTabbed_carousel_img {
      width: 100%;
      background-color: rgb(235, 235, 235);
      @media ${(props) => props.theme.mediaQuery.large} {
        max-width: unset;
      }

      @media (min-width: 1024px) and (max-width: 1064px),
        (min-width: 500px) and (max-width: 550px),
        (min-width: 850px) and (max-width: 900px) {
        max-width: unset;
      }
    }

    .carousel-arrows .right-arrow {
      position: absolute; /* Assuming you want to position it absolutely */
      right: 26px;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #d8d8d8; /* Use hex for consistency */
      background-color: rgba(255, 255, 255, 0.9);
      background-image: url(${(props) => getIconPath(ICON_NAME, props)});
      background-position: center;
      background-repeat: no-repeat;
    }

    .carousel-arrows .left-arrow {
      position: absolute; /* Assuming you want to position it absolutely */
      left: 26px;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #d8d8d8; /* Use hex for consistency */
      background-color: rgba(255, 255, 255, 0.9);
      background-image: url(${(props) => getIconPath(ICON_NAME, props)});
      background-position: center;
      background-repeat: no-repeat;
      z-index: 10;
    }
  }

  .promotion-section-pdp-wrapper {
    display: flex;
    column-gap: 12px;
    background: #dbebf8;
    padding: 8px;
    border-radius: 6px;
    margin-bottom: 8px;
    align-items: center;
    height: 33px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-bottom: 12px;
    }
  }

  .loyalty-promotion-banner {
    background: ${(props) => (props.isPlcc ? '#dbebf8' : '#fef4e8')};
  }

  .plcc-discounted-price {
    font-size: 20px;
    font-weight: 800;
    color: #254f6e;
  }

  .promotion-section-pdp-icon {
    width: 76px;
    min-width: 76px;
    justify-content: center;
    align-items: center;
    display: flex;
    @media ${(props) => props.theme.mediaQuery.mediumMax && props.isPLCCBannerPriceEnabled} {
      width: 50px;
      min-width: 50px;
    }
  }

  .promotion-section-pdp-text {
    font-size: 14px;
    color: #254f6e;
    font-weight: 600;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: 11px;
    }
  }

  .promotion-section-pdp-left-arrow {
    margin-left: auto;
  }

  .loyalty-promotion-text {
    color: #1a1a1a;
  }

  @media (min-width: 1800px) {
    .product-content-wrapper {
      ${(props) =>
        props.isNewPJPPDPRedesignEnabled
          ? `margin-right:14px!important;margin-left:13px !important;width:100% !important;`
          : ``}
    }
  }

  @media ${(props) => props.theme.mediaQuery.desktop} {
    .product-content-wrapper {
      width: ${(props) => (props.isPdpPage ? '100%' : 'calc(100% - 26px)')};
    }
  }

  .product-summary-new-pdp {
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }

  .new-pdp-product-detail-below-wrapper {
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }
  .placeholder div {
    background: #d8d8d8;
    padding: 10px 0;
    margin-bottom: 5px;
    text-align: center;
  }
  .also-available {
    @media only screen and (min-width: 1920px) {
      ${(props) => props.isFamilyOutfitRightViewEnabled && `display: none;`}
    }
    font-family: Nunito;
    font-size: 16px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.88;
    letter-spacing: 0.57px;
    color: #1a1a1a;
    margin-top: 26px;
  }
  .family-outfit-two-item {
    .slick-slide {
      width: 30% !important;
    }
  }

  .family-outfit-carousel-block {
    @media only screen and (min-width: 1920px) {
      ${(props) => props.isFamilyOutfitRightViewEnabled && `display: none;`}
    }
    margin-bottom: 32px;
    margin-top: 16px;
    padding-bottom: 24px;
    border: solid 1px #d8d8d8;
    background-color: #ffffff;
    max-height: 183px;

    .slick-slide {
      width: 150px !important;
      position: relative;
    }
    .slick-track {
      display: flex;
      justify-content: center;
    }
    .slick-arrow.slick-prev,
    .slick-arrow.slick-next {
      display: block;
      height: 35px;
      width: 15px;
      top: 111.5px;
    }
    .slick-arrow.slick-prev {
      left: -50px;
      top: 111.5px;
    }
    .slick-arrow.slick-prev.slick-disabled {
      background: url(${(props) => getIconPath('family-outfit-disabled-arrow', props)}) no-repeat;
      transform: translate(0, -50%);
      position: absolute;
      top: 111.5px;
      height: 35px;
      width: 15px;
      left: -50px;
    }

    .slick-arrow.slick-next.slick-disabled {
      background: url(${(props) => getIconPath('family-outfit-disabled-arrow', props)}) no-repeat;
      transform: rotateY(180deg) translate(0, -50%);
      top: 111.5px;
      right: -50px;
    }

    .slick-arrow.slick-next {
      right: -50px;
      top: 111.5px;
    }
    .slick-dots {
      top: 180px;
      bottom: auto;
      position: absolute;
    }
    li.slick-active {
      margin: 0px;
      margin-top: 4px;
      width: 10px;
      height: 10px;
      padding-right: 35px;
    }
    .slick-dots li {
      position: relative;
      display: inline-block;
      margin: 0 2px;
      width: 6px;
      height: 6px;
      padding-right: 36px;
    }
    .slick-dots li button:before {
      content: '';
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      width: 48px;
      height: 2px;
      border-radius: 4px;
      background: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      .slick-arrow {
        display: none !important;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      .slick-dots {
        display: none;
      }
      .tcp_carousel_wrapper {
        margin-left: 64px;
        margin-right: 64px;
      }
    }

    .family-outfit-carousel-img {
      margin-top: 24px;
      height: 108px;
      max-width: 70px;
      margin-bottom: 5px;
      object-fit: cover;
      @media ${(props) => props.theme.mediaQuery.large} {
        max-width: calc(100% - 10px);
        height: 154px;
      }
    }
    .family-carousel-item-name {
      font-family: Nunito;
      font-size: 11px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.39px;
      color: #1a1a1a;
      margin-bottom: 30px;
      display: inline-block;
      @media ${(props) => props.theme.mediaQuery.large} {
        margin-bottom: 24px;
      }
    }
    .family-outfit-carousel-plus-icon {
      font-size: 16px;
      font-weight: bold;
      color: #1a1a1a;
      position: absolute;
      top: 67px;
      right: 0px;
      @media ${(props) => props.theme.mediaQuery.large} {
        top: 100px;
      }
    }
    .slick-arrow .slick-prev,
    .slick-arrow .slick-next {
      width: 19px;
      height: 39px;
    }
    .image-link {
      display: inline-block;
      @media ${(props) => props.theme.mediaQuery.large} {
        height: 0;
      }
    }
  }
  .carousel-container {
    position: relative;
    width: 100%;
  }

  .product-detail-section {
    flex: 1;
    @media ${(props) => props.theme.mediaQuery.medium} {
      .product-description-list {
        padding: 0px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      margin-right: 30px;
    }
    position: relative;
    background-color: ${(props) => props.theme.colors.WHITE};
  }
  .key-feature-section {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      background: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    }
  }

  .hide-promo {
    display: none;
  }
  .product-description-list {
    position: relative;
    background-color: ${(props) => props.theme.colors.WHITE};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      border-radius: 18px;
    }
  }
  .pdp-tabs-view-description {
    padding-top: 28px;
    padding-bottom: 14px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      padding: 24px 12px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-top: 38px;
    }
  }
  .pdp-tabs-view-features {
    padding-bottom: 36px;
    font-size: 22px;
    font-weight: 700;
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-bottom: 48px;
      font-weight: 900;
    }
  }
  .product-detail-section.complete-look-section {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      background: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    }
    ${(props) =>
      props.isRedesignedPdpDesktopView
        ? `
        .slick-slider {
          @media ${props.theme.mediaQuery.desktop} {
            margin: 0;
          }
        }`
        : ''}
    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) => (props.isVerticalCTLEnabled ? `display:none` : ``)}
    }
    .product-description-list {
      @media ${(props) => props.theme.mediaQuery.desktop} {
        ${(props) => (props.isVerticalCTLEnabled ? `border-top: none;` : ``)}
      }
    }
  }

  .sticky-product-detail {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      z-index: 1;
    }
  }
  .full-size-desktop-image {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      z-index: -1;
    }
  }
  .product-content-wrapper {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      position: relative;
      z-index: 1;
    }
  }
  .sticky-product-detail-section {
    @media ${(props) => props.theme.mediaQuery.medium} {
      position: sticky;
      top: 70px;
    }
  }
  .product-description-list.complete-the-look-section.add-border {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      padding: 0 10px;
    }
  }
  .also-available-wrapper-new-design {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(
        props
      ) => `border: ${props.theme.spacing.ELEM_SPACING.SM} solid  ${props.theme.colors.PRIMARY.PALEGRAY};
      margin: 0px -${props.theme.spacing.ELEM_SPACING.REG};
      padding: ${props.theme.spacing.ELEM_SPACING.SM};
      background: ${props.theme.colors.WHITE};`}
    }
  }
  .loyalty-banner-wrapper-new-design {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(
        props
      ) => `border: ${props.theme.spacing.ELEM_SPACING.SM} solid  ${props.theme.colors.PRIMARY.PALEGRAY};
        margin: 0px -${props.theme.spacing.ELEM_SPACING.REG};
        padding: ${props.theme.spacing.ELEM_SPACING.SM};
        border-radius: ${props.theme.spacing.ELEM_SPACING.MED_1};background: ${props.theme.colors.WHITE};`}
      ${(props) => (props.isNewPJPPDPRedesignEnabled ? `border:none;` : ``)}
    }
  }
  .loyalty-banner-wrapper {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) =>
        ` padding: ${props.theme.spacing.ELEM_SPACING.MED_1} 0 ${props.theme.spacing.ELEM_SPACING.XL}`};
    }
  }
  .product-image-wrapper {
    margin-right: 0;
    min-height: 450px;
  }
  .sticky-mobile-image-wrapper {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-top: 13px;
      position: sticky;
      position: -webkit-sticky;
      top: 25px;
      z-index: -1;
      -webkit-transform: translateZ(-1);
    }
  }
  .product-detail-image-wrapper {
    margin-bottom: 8px;
  }
  .product-breadcrumb-wrapper {
    min-height: 20px;
    padding-top: ${(props) => (props.isDefaultBreadCrumb ? '7' : '25')}px;
    padding-bottom: 7px;
  }
  .button-go-back {
    border: none;
    display: flex;
    align-items: center;
    background: transparent;
    cursor: pointer;
  }
  .back-button {
    margin-left: 5px;
    color: ${(props) => props.theme.colors.TEXT.BLUE};
  }
  .go-back-container {
    padding-bottom: 18px;
    ${(props) =>
      props.isPDPRedesignEnabled &&
      `
    padding-bottom:0;
    `}
    button {
      padding-left: 0;
    }
  }
  .product-summary-mobile-view {
    display: flex;
  }
  div.product-property-section {
    margin: 0;
    padding: 10px 0 20px;
    width: 100%;
  }
  .product-summary-desktop-view {
    display: none;
  }
  .promo-area-top {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  }
  .pdp-qty {
    padding-top: 5px;
  }
  .promo-area-middle {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .promo-area-dynamic {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .promo-area-bottom {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .product-summary-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0 0 0;
      ${(props) =>
        props.productInfo?.isGiftCard || props.isPDPRedesignEnabled ? 'padding-bottom: 0px;' : ''};

      border-left: 0;
      border-right: 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => !props.isPDPRedesignEnabled && ` min-height: 258px;`}
      border-bottom: none;
      ${(props) =>
        !props.isNewPJPPDPRedesignEnabled
          ? `padding: ${props.theme.spacing.ELEM_SPACING.SM} 0 0 0;`
          : ``}
    }
    .item-rating-meta {
      display: none;
    }
    .actual-price {
      font-size: ${(props) => props.theme.typography.fontSizes.fs24};
      color: ${(props) => props.theme.colorPalette.red[500]};
      display: inline-block;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        ${(props) => `font-size: ${props.theme.typography.fontSizes.fs18};`}
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: 28px;
      }
    }

    .offer-price-product {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: 28px;
      }
    }

    .original-price {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      color: ${(props) => props.theme.colorPalette.gray[600]};
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      }
    }

    .list-price-product {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: 9px;
      }
    }
    .points-and-rewards {
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      font-size: 14px;
    }
    .points-and-rewards-1 {
      color: ${(props) => props.theme.colors.PROMO.ORANGE};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    }
    .points-and-rewards-2 {
      color: ${(props) => props.theme.colors.PROMO.BLUE};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    }
    .points-and-rewards-or {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      color: ${(props) => props.theme.colors.BLACK};
      font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      .product-details-header-container {
        ${(props) =>
          !props.isNewPJPPDPRedesignEnabled
            ? `margin-top: ${props.theme.typography.fontSizes.fs13};`
            : ``}
      }
    }

    .inline-badge-item {
      margin-bottom: 4px;
    }
  }
  .pdp-redesigned {
    padding-top: 0px;
  }
  .product-summary-non-mobile-view-new-design {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: none !important;
    }
  }
  .product-summary-mobile-view-new-design {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none !important;
    }
  }
  .size-chart-btn-pdp {
    ${(props) => (props.isNewPJPPDPRedesignEnabled ? `right:0;` : ``)}
  }
  .clear-button {
    border: none;
    background: transparent;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    padding-bottom: 0;
    width: 35px;
    cursor: pointer;
  }
  .product-price-mobile-view {
    display: flex;
  }
  .product-price-desktop-view {
    display: none;
  }

  .pdp-price-container {
    min-height: 58px;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-image-wrapper {
      margin-right: 30px;
    }
    .product-detail-image-wrapper {
      margin-bottom: 11px;
    }
    .product-summary-mobile-view {
      display: none;
    }
    .product-summary-desktop-view {
      display: flex;
    }
    .product-price-mobile-view {
      display: none;
    }
    .product-price-desktop-view {
      display: flex;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .product-image-wrapper {
      margin-right: 0;
      ${(props) => props.addToDefaultFavoritesEnabled && 'margin-right: 12px;'}
    }
    .product-detail-image-wrapper {
      margin-bottom: 27px;
    }
    .product-summary-mobile-view {
      display: none;
    }
    .product-summary-desktop-view {
      display: flex;
    }
    .product-price-mobile-view {
      display: none;
    }
    .product-price-desktop-view {
      display: flex;
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    .go-back-container {
      padding-bottom: 36px;
      ${(props) =>
        props.isPDPRedesignEnabled &&
        `
      padding-bottom:0;
      `}
    }
  }

  @media ${(props) => props.theme.mediaQuery.desktop} {
    .product-image-wrapper {
      ${(props) => props.addToDefaultFavoritesEnabled && 'margin-right: 0;'}
    }
  }

  .loyalty-banner {
    padding-right: 0;
    padding-left: 0;
  }
  .get-candid-section {
    flex: 1;
  }
  .complete-the-look-test {
    .slick-dots {
      .slick-active {
        height: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
        width: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
    }
    .slick-dots .slick-active button {
      height: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      width: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      &:before {
        height: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
        width: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
    }
  }
  .pdp-recommendations-wrapper {
    position: relative;
    background-color: ${(props) => props.theme.colors.WHITE};
    overflow-x: hidden;
    .pdp-vertical-recomendation {
      @media ${(props) => props.theme.mediaQuery.desktop} {
        display: none;
      }
    }
    .ctl-heading {
      font-family: nunito;
      font-weight: 700;
      font-size: 20px !important;
      margin-top: 10px !important;
      display: none;
    }
    .ctl-v3-container {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-left: 16px;
      }
    }
    #stylitics-widget-container .stylitics-bundle-badge,
    #stylitics-composer-container .stylitics-bundle-badge {
      margin: -5%;
      padding-top: 50%;
      padding-left: 25%;
      font-size: 18px;
      font-weight: 400;
      font-family: nunito;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
    #stylitics-widget-container .stylitics-bundle-badge:hover,
    #stylitics-composer-container .stylitics-bundle-badge:hover {
      margin: -5%;
      padding-top: 50%;
      padding-left: 25%;
      font-size: 18px;
      font-weight: 400;
      font-family: nunito;
      opacity: 1;
      height: 100%;
      width: 100%;
      ${(props) =>
        props.outfitV3WidgetVDABTestEnabled ? `` : `background-color: rgba(255, 255, 255, 0.7)`};
    }
    #stylitics-widget-container .stylitics-bundle-gallery,
    #stylitics-composer-container .stylitics-bundle-gallery {
      margin: 0px;
    }
  }

  ${(props) =>
    props.isRedesignedPdpDesktopView
      ? `@media ${props.theme.mediaQuery.desktop} {
    .recommendations-section-col {
       margin-left: 100px;
      width: 88%;
    }
    .moduleO-variation {
      justify-content: flex-start;
    }
    .no-carousel-container.moduleO-variation {
      justify-content: flex-start;
      margin-left: -15px;
    }
  }`
      : ''}

  .right-scroll-container-wrapper {
    @media ${(props) => props.theme.mediaQuery.desktop} {
      display: flex;
      justify-content: end;
      .recommendations-section-col {
        margin-left: 50px;
        width: 100%;
      }
      .complete-the-look-section {
        border-top: none;
        display: block;
      }
      .sticky-wrapper {
        position: sticky;
        top: 100px;
        height: fit-content;
        max-height: 100%;
      }
    }
  }

  .recommendations-section-row {
    min-height: 320px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-height: 380px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 436px;
    }
  }

  .syte-slider-layout-container {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      border-width: 10px 7px 0px 7px;
      border-style: solid;
      border-color: ${(props) => props.theme.colorPalette.gray[300]};
      padding: 6px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .product-content-wrapper .wishlist-container-wrapper {
      left: 145px;
      padding: 0;
      width: 41px;
      height: 41px;

      .fav-icon-wrapper {
        width: 41px;
        height: 41px;
        place-content: center;
      }
      .clear-button {
        padding: 0 !important;
        width: 26px;
        height: 26px;
      }
    }
  }

  /* stylelint-disable max-nesting-depth */
  form.pdp-new-design-form {
    margin-top: 0px;

    .edit-form-css {
      margin-top: 0px;
    }

    .size-and-fit-detail-title.quick-view-drawer-redesign,
    .color-selector .image-chips-selector-title,
    .pack-label {
      color: #1a1a1a;
      font-family: Nunito;
      font-size: 15px;
      font-style: normal;
      font-weight: 800;
      line-height: 14px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      margin: 0 4px 0 0;
      padding: 0;
    }

    .quick-view-drawer-redesign.size-and-fit-detail-items-list,
    .new-quick-view-drawer.image-chips-selector-items-list,
    .multipack-tab.quick-view-drawer-redesign {
      margin: 12px 0 0 0;
      padding-top: 0;
    }

    .quick-view-drawer-redesign.size-and-fit-detail-items-list {
      gap: 12px;
      align-items: center;
      width: 100%;
      left: 0;

      label {
        margin: 0px;
      }
    }

    .new-quick-view-drawer.image-chips-selector-items-list {
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        label {
          margin: 0 10px 0 0;
        }
      }

      @media ${(props) => props.theme.mediaQuery.medium} {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 10px;

        label {
          margin: 0px;
        }
      }
    }

    .multipack-tab-edit-css {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .multipack-tab.quick-view-drawer-redesign {
      margin-bottom: 24px;

      @media ${(props) => props.theme.mediaQuery.smallMax} {
        padding-bottom: 0;

        li {
          margin: 0 12px 0 0;
        }
      }

      @media ${(props) => props.theme.mediaQuery.medium} {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        li {
          margin: 0;
        }
      }
    }

    .size-selector {
      margin-top: 0;

      .size-field-error.quick-view-drawer-redesign.size-and-fit-detail-items-list {
        padding-bottom: 10px;
      }
    }

    .color-selector.department-swatch,
    .color-selector,
    .fit-selector {
      margin: 0 0 24px 0;
    }

    .selected-field-value,
    .color-selector .image-chips-selector-title-name,
    .selected-pack-value {
      color: #1a1a1a;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      padding: 0;
      margin: 0;
    }
  }
`;

export const recommendationStylesPdp = css`
  .accordion-recommendation {
    text-transform: initial;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: none;
    font-size: 22px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 18px;
      padding: 12px 0 0 0px;
      margin: 12px 0 0 0px;
    }
    font-weight: bold;
  }

  .recommendations-section-row {
    position: relative;
    top: 14px;
  }

  .accordion-recommendation:before {
    content: '';
    border-top: 1px solid;
    margin: 0 20px 0 0;
    flex: 0.41 0 20px;
  }

  .accordion-recommendation:after {
    content: '';
    border-top: 1px solid;
    margin: 0 0 0 20px;
    flex: 0.41 0 20px;
  }

  .smooth-scroll-list-item {
    margin-right: 5px;
  }

  .container-price p {
    font-size: 18px;
  }
  .container-price span {
    top: -4px;
    position: relative;
  }

  .recommendations-container {
    border-bottom: 7px solid ${(props) => props.theme.colors.ACCORDION.ACTIVE_HEADER};
    padding-bottom: 20px;
    @media ${(props) => props.theme.mediaQuery.large} {
      border-bottom: 1px solid ${(props) => props.theme.colors.ACCORDION.ACTIVE_HEADER};
    }
  }

  .product-image-container {
    height: 237px !important;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 286px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      height: 190px !important;
      min-width: 150px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 170px !important;
      min-width: 120px;
    }
  }

  .product-image-container img {
    top: 0px !important;
    left: 0px !important;
    transform: none !important;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .smooth-scroll-list-item {
      width: 38%;
    }
  }
`;

export const StyledModuleLoader = styled.div`
  background-color: ${({ theme }) => theme.colors.PRIMARY.LIGHTGRAY};
  position: absolute;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) =>
      props.aspectRatioObject && applyAspectRatioBoxStyles(props.aspectRatioObject, 'MOBILE', true)}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) =>
      props.aspectRatioObject && applyAspectRatioBoxStyles(props.aspectRatioObject, 'TABLET', true)}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.aspectRatioObject &&
      applyAspectRatioBoxStyles(props.aspectRatioObject, 'DESKTOP', true)}
  }
  & .module-loader {
    position: static;
  }
`;

export const customSubmitButtonStyle = css`
  .add-to-bag-button {
    max-width: none;
  }
  ${(props) =>
    props.isGiftCard
      ? `.button-wrapper {
    margin-top: ${props.theme.spacing.ELEM_SPACING.XXL};
    margin-bottom: ${props.theme.spacing.ELEM_SPACING.LRG};
  }
  .qty-selector {
    margin-top: 40px;
  }
  @media ${props.theme.mediaQuery.smallOnly} {
    .edit-form-css {
      margin-top: ${props.productInfo.isGiftCard ? '0px' : props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  `
      : ``}
  @media ${(props) => props.theme.mediaQuery.medium} {
    .add-to-bag-button {
      max-width: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .add-to-bag-button {
      max-width: 450px;
    }
  }
`;

export const recommendationStylesPdp1AndPdp2 = css`
  .recommendations-header {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: 14px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1a1a1a;
  }

  .container-price {
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-height: 47px !important;
    }
  }

  .product-wishlist-container + .fulfillment-section {
    margin-top: 23px;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-list {
      margin: 0px;
    }
  }
`;

export const StyledPDPRecommendationWrapper = styled.div`
  .right-scroll-container-wrapper {
    display: none;

    @media ${(props) => props.theme.mediaQuery.desktop} {
      display: flex;
      justify-content: end;
      position: fixed;
      top: ${(props) => props.top}px;
      right: 0;
      z-index: 1;
      overflow-y: scroll;
      height: calc(100% - ${(props) => props.top}px);
      border-left: 2px solid #d8d8d8;
      border-top: 2px solid #d8d8d8;
      background: #fff;
      margin: 0 !important;
      width: 186px;
      transition: top 0.3s;

      .recommendations-section-row {
        width: 186px;
      }

      .recommendations-container-new > .recommendations-header {
        margin: 0px !important;
        text-align: center;
        padding: 5px;
      }

      .item-container-inner {
        margin: 0;
        border-bottom: 1px solid #d8d8d8;
        border-left: none;
        border-right: none;
        border-top: none;
        border-radius: 0;
      }

      .recommendations-section-col {
        margin-left: 0;
        width: 100%;
      }
      .complete-the-look-section {
        border-top: none;
        display: block;
      }
      .sticky-wrapper {
        top: 100px;
        height: fit-content;
        max-height: 100%;
      }
    }
  }
`;

export const StyledPdpWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.desktop} {
    width: ${(props) =>
      props.showVerticleScrollContainer
        ? `calc(100% - ${props.isNewPJPPDPRedesignEnabled ? '0px' : '186px'})`
        : '100%'};
  }
`;
